/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { ContentTemplateCategoryMetaTable } from "./ContentTemplateCategoryMetaTable";
import { ContentTemplateFieldMetaTable } from "./ContentTemplateFieldMetaTable";
import { ContentTemplateMetaTable } from "./ContentTemplateMetaTable";
import { ContentTemplateTagMetaTable } from "./ContentTemplateTagMetaTable";
import { EnvService } from "namirasoft-core";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftContentTemplateServer } from "../NamirasoftContentTemplateServer";
import { TokenManager } from "namirasoft-account";

export class NamirasoftContentTemplateMetaDatabase extends NSBaseMetaDatabase<NamirasoftContentTemplateServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        content_template: ContentTemplateMetaTable,
        content_template_category: ContentTemplateCategoryMetaTable,
        content_template_field: ContentTemplateFieldMetaTable,
        content_template_tag: ContentTemplateTagMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-b1360c432dc04a27", name: "Namirasoft Content Template", headline: "Standardized Content Management", description: "Content Template allows you to manage and customize text efficiently to streamline messaging. Simply adjust the parameters you need to change, ensuring consistency in your communications.", logo: "https://static.namirasoft.com/image/namirasoft/content-template/logo/base.png", link: "https://content-template.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            content_template: new ContentTemplateMetaTable(this),
            content_template_category: new ContentTemplateCategoryMetaTable(this),
            content_template_field: new ContentTemplateFieldMetaTable(this),
            content_template_tag: new ContentTemplateTagMetaTable(this),
        };
    }
    override getServer(): NamirasoftContentTemplateServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftContentTemplateMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftContentTemplateServer(BASE_URL, this.manager, this.onError);
    }
};